/**
 * NEXORA AI - CountryStep (Refactorisé avec Design System)
 * Epic 1.3 Phase 2.2 - Onboarding Premium
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import SelectionCard, { SelectionCardGrid } from '../ui/selection-card';
import StepHeader from '../ui/step-header';
import ValidationMessage from '../ui/validation-message';

const POPULAR_COUNTRIES = [
  { id: 'fr', label: 'France', icon: '🇫🇷' },
  { id: 'us', label: 'United States', icon: '🇺🇸' },
  { id: 'gb', label: 'United Kingdom', icon: '🇬🇧' },
  { id: 're', label: 'Réunion', icon: '🇷🇪' },
  { id: 'mu', label: 'Maurice', icon: '🇲🇺' },
  { id: 'mg', label: 'Madagascar', icon: '🇲🇬' }
];

export default function CountryStep({ data, onNext, onBack, onData }) {
  const { t } = useTranslation('onboarding');
  const [selected, setSelected] = useState(data.country || null);
  const [search, setSearch] = useState('');
  const [showValidation, setShowValidation] = useState(false);

  const handleSelect = (countryId) => {
    setSelected(countryId);
    onData({ country: countryId });
  };

  const handleNext = () => {
    if (selected) {
      setShowValidation(true);
      setTimeout(() => onNext(), 1200);
    }
  };

  const filteredCountries = POPULAR_COUNTRIES.filter((c) =>
    c.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen flex items-center justify-center p-4 sm:p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-4xl"
      >
        <StepHeader
          icon={<MapPin className="text-indigo-400" />}
          title={t('country_title')}
          subtitle={t('country_subtitle')}
        />

        {/* Search */}
        <div className="mb-6">
          <Input
            type="text"
            placeholder="Rechercher un pays..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="h-12 bg-zinc-900/50 border-zinc-800"
          />
        </div>

        <SelectionCardGrid cols={3} className="mb-8">
          {filteredCountries.map((country) => (
            <SelectionCard
              key={country.id}
              id={country.id}
              selected={selected === country.id}
              onSelect={handleSelect}
              icon={country.icon}
              title={country.label}
              size="md"
            />
          ))}
        </SelectionCardGrid>

        <ValidationMessage
          show={showValidation}
          type="success"
          message={t('validation_country')}
        />

        <div className="flex justify-between items-center">
          <Button variant="ghost" onClick={onBack} className="min-h-[44px]">
            {t('back')}
          </Button>
          <Button
            onClick={handleNext}
            disabled={!selected || showValidation}
            className="min-h-[44px] bg-indigo-600 hover:bg-indigo-500"
          >
            {t('continue')}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
